import { type FC } from "react";

import { Button } from "../../../Button";
import { type ColorVariant, colorVariantOptions } from "../../../Chip/types";
import { Popover } from "../../../PopoverV2";
import { TagColor } from "./TagColor";
import { TagColorChoice } from "./TagColorChoice";

export const TagColorSelector: FC<{
	selectedColor: ColorVariant;
	onColorChange: (color: ColorVariant) => void;
}> = ({ selectedColor, onColorChange }) => {
	return (
		<Popover.Root>
			<Popover.Trigger asChild>
				<Button className="h-8 w-8" level="tertiary" size="md">
					<TagColor color={selectedColor} />
				</Button>
			</Popover.Trigger>
			<Popover.Portal>
				<Popover.Content>
					<div className="grid grid-cols-4 gap-2">
						{colorVariantOptions.map((color) => (
							<TagColorChoice
								key={color}
								color={color}
								label={color}
								selected={selectedColor === color}
								onClick={onColorChange}
							/>
						))}
					</div>
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>
	);
};
